import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getJob, editJob } from "./jobAPI";

const initialState = {
  isLoading: false,
  job: {},
  error: "",
};

export const fetchJob = createAsyncThunk("job/fetchJob", async (id) => {
  const job = await getJob(id);
  return job;
});

export const modifyJob = createAsyncThunk(
  "job/editJob",
  async ({ id, data }) => {
    const job = await editJob(id, data);
    return job;
  }
);

export const jobSlice = createSlice({
  name: "job",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchJob.pending, (state) => {
        state.isLoading = true;
        state.job = {};
        state.error = "";
      })
      .addCase(fetchJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.job = action.payload;
        state.error = "";
      })
      .addCase(fetchJob.rejected, (state, action) => {
        state.isLoading = false;
        state.job = {};
        state.error = action.error?.message;
      });
    builder
      .addCase(modifyJob.pending, (state) => {
        state.isLoading = true;
        state.job = {};
        state.error = "";
      })
      .addCase(modifyJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.job = action.payload;
        state.error = "";
      })
      .addCase(modifyJob.rejected, (state, action) => {
        state.isLoading = false;
        state.job = {};
        state.error = action.error?.message;
      });
  },
});

export default jobSlice.reducer;
